

export interface IEnvironmentConfig {
    r2path: string;
    submissionApiUrl: string;
    defaultBrandId: string;
    rollbarKey: string;
}


const getAppConfig = () => {
    const running_env = import.meta.env.VITE_APP_ENVIRONMENT
    console.log("VITE_APP_ENVIRONMENT: ", running_env)

    const default_config: IEnvironmentConfig = {
        r2path: "https://dev.assets.radcliffesurveys.com",
        submissionApiUrl: "/submit",
        defaultBrandId: "0004",
        rollbarKey: "",
    }

    if (running_env === "rad-test") {
        default_config.r2path = "https://dev.assets.radcliffesurveys.com"
        default_config.submissionApiUrl = "https://dev.radcliffesurveys.com/submit"
        default_config.rollbarKey = "7db09dc3060347fa8218967e3c5793ae"        
    }
    else if (running_env === "rad-prod") {
        default_config.r2path = "https://assets.radcliffesurveys.com"
        default_config.submissionApiUrl = "https://radcliffesurveys.com/submit"
        default_config.rollbarKey = "7db09dc3060347fa8218967e3c5793ae"
    }

    console.log(`config : ${JSON.stringify(default_config)}`)

    return default_config
}

export const appConfig = getAppConfig();

